import axios from "axios";
import { logout } from '../store/slices/authSlice';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://karta.narodnichitalishta.bg/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const setupInterceptors = (store) => {
  // REQUEST: закачаме токена към всяка заявка
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // RESPONSE: обновяваме токена ако сървърът е върнал нов, или redirect при 401/403
  api.interceptors.response.use(
    (response) => {
      // Сървърът връща нов токен само когато стария изтича скоро (sliding expiration).
      // Authorization хедърът е expose-нат чрез CorsConfigurationSource.setExposedHeaders.
      const authHeader = response.headers['authorization'];
      if (authHeader && authHeader.startsWith('Bearer ')) {
        const newToken = authHeader.substring(7);
        localStorage.setItem('token', newToken);
        // Обновяваме default хедъра за следващите заявки
        api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
        // console.log("JWT token refreshed via sliding expiration.");
      }

      return response;
    },
    (error) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        console.warn("Session expired or unauthorized. Redirecting to login...");

        // Изчистваме сесията в Redux и localStorage
        store.dispatch(logout());

        // Redirect към login само ако не сме вече там
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/admin/login')) {
          // Запазваме текущия path за да се върнем след успешен login
          window.location.href = '/admin/login';
        }
      }

      return Promise.reject(error);
    }
  );
};

export default api;